import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "SendAlt"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M20.5871 11.3325L4.08705 3.08251C3.82289 2.9504 3.50578 2.98563 3.27705 3.17251C3.05895 3.35531 2.96308 3.6458 3.02955 3.92251L5.24955 12L2.99955 20.055C2.93754 20.2848 2.98824 20.5303 3.13617 20.7167C3.28411 20.9031 3.51173 21.0082 3.74955 21C3.86696 20.9993 3.98256 20.9711 4.08705 20.9175L20.5871 12.6675C20.8375 12.5392 20.9951 12.2814 20.9951 12C20.9951 11.7186 20.8375 11.4608 20.5871 11.3325ZM4.91196 18.8325L6.56946 12.75H13.4995V11.25H6.56946L4.91196 5.16751L18.5695 12L4.91196 18.8325Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/SendAlt.vue"]]);
